const CalculatePagination = (pagination)=>{
  const { page, rowsPerPage, count } = pagination;
  const from = rowsPerPage * page + 1;
  const maxTo = rowsPerPage * (page + 1);
  const to = count <= maxTo?count:maxTo
  const total = count;
  return {from,to,total}
}

export default CalculatePagination